import React from "react";
import { Box, Skeleton, Grid, Paper } from "@mui/material";

const LoadingPage = () => {
    return (
        <Box sx={{ bgcolor: 'background.default', height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Header / Nav Mockup */}
            <Box sx={{ px: 3, py: 2, borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <Skeleton variant="circular" width={40} height={40} animation="wave" />
                        <Box>
                            <Skeleton variant="text" width={120} height={24} animation="wave" />
                            <Skeleton variant="text" width={80} height={16} animation="wave" />
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Skeleton variant="circular" width={32} height={32} animation="wave" />
                        <Skeleton variant="circular" width={32} height={32} animation="wave" />
                    </Box>
                </Box>
            </Box>

            {/* Tabs Mockup */}
            <Box sx={{ px: 2, borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', display: 'flex', gap: 3 }}>
                {[1, 2, 3, 4].map((i) => (
                    <Box key={i} sx={{ py: 2, px: 1 }}>
                        <Skeleton variant="text" width={70} height={20} animation="wave" />
                    </Box>
                ))}
            </Box>

            {/* Main Content: Activity List Mockup */}
            <Box sx={{ flex: 1, p: 0 }}>
                {/* Section Header */}
                <Box sx={{ px: 3, py: 2, bgcolor: 'rgba(255,255,255,0.02)' }}>
                    <Skeleton variant="text" width={150} height={28} animation="wave" />
                </Box>

                {/* Horizontal Activity Rows */}
                {[1, 2, 3, 4, 5, 6].map((item) => (
                    <Box
                        key={item}
                        sx={{
                            px: 3,
                            py: 2.5,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2.5,
                            borderBottom: '1px solid',
                            borderColor: 'divider',
                            bgcolor: 'background.paper',
                            transition: 'opacity 0.3s ease'
                        }}
                    >
                        {/* Time Side */}
                        <Box sx={{ minWidth: 70, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                            <Skeleton variant="text" width={50} height={24} animation="wave" sx={{ borderRadius: 0.5 }} />
                            <Skeleton variant="text" width={40} height={18} animation="wave" sx={{ opacity: 0.4, borderRadius: 0.5 }} />
                        </Box>

                        {/* Content Side */}
                        <Box sx={{ flex: 1 }}>
                            <Skeleton variant="text" width="70%" height={28} animation="wave" sx={{ mb: 0.5, borderRadius: 0.5 }} />
                            <Skeleton variant="text" width="45%" height={18} animation="wave" sx={{ opacity: 0.4, borderRadius: 0.5 }} />
                        </Box>

                        {/* End Badge/Icon */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Skeleton variant="circular" width={28} height={28} animation="wave" sx={{ opacity: 0.3 }} />
                            <Skeleton variant="rectangular" width={16} height={16} animation="wave" sx={{ opacity: 0.2, borderRadius: 0.5 }} />
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default React.memo(LoadingPage);